
    import '/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.zh-CN.md?type=demo')
};